import { useMemo } from 'react';
import { useSalesforceData } from './useSalesforceData';
import type { SalesforceUser } from '../types/gtm';

const USERS_QUERY =
  "SELECT Id, Name, UserRole.Name, IsActive FROM User WHERE IsActive = true AND Profile.Name = 'Sales' ORDER BY Name";

export function useSalesforceUsers() {
  const { data, loading, error } = useSalesforceData<SalesforceUser>(USERS_QUERY);

  const userOptions = useMemo(
    () =>
      data.map((u) => ({
        value: u.Id,
        label: u.Name,
        role: u.UserRole?.Name ?? '',
      })),
    [data]
  );

  return { userOptions, loading, error };
}
